























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { NumberSequence as INumberSequence } from "@/api-v2/document-number/models/number-sequence";
import { sprintf } from "@/utils/sprintf";
import Modal from "@/components/form/Modal.vue";
import { documentNumberApi } from "@/getinfo-api";
import {
  NumberSequenceEdit as INumberSequenceEdit,
  NumberSequenceEditTypeEnum
} from "@/api-v2/document-number/models/number-sequence-edit";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import { currentUserIsCompanyOwner, isRoot } from "@/plugins/roles";

@Component({
  components: { TableActions, CustomTableCol, CustomTableItem, Modal }
})
export default class DocumentNumberItem extends Vue {
  @Prop() sequence!: INumberSequence;
  @Prop() companyId!: string;
  title: string = this.sequence.title;
  isEdit?: boolean = false;
  isShowSpinner = false;
  type: NumberSequenceEditTypeEnum | INumberSequenceEdit | any = this.sequence
    .type;

  get translateType() {
    let translateType;
    if (this.type === NumberSequenceEditTypeEnum.Unset) {
      translateType = this.$t(this.$translate.All);
    } else if (this.type === NumberSequenceEditTypeEnum.Contract) {
      translateType = this.$t(this.$translate.Contract);
    } else if (this.type === NumberSequenceEditTypeEnum.Act) {
      translateType = this.$t(this.$translate.CertificateOfCompletedWorks);
    } else if (this.type === NumberSequenceEditTypeEnum.Bill) {
      translateType = this.$t(this.$translate.Bill);
    } else if (this.type === NumberSequenceEditTypeEnum.FinalDocument) {
      translateType = this.$t(this.$translate.FinalDocument);
    } else if (this.type === NumberSequenceEditTypeEnum.EnrollmentOrder) {
      translateType = this.$t(this.$translate.OrderOfEnrollment);
    } else if (this.type === NumberSequenceEditTypeEnum.ExpulsionOrder) {
      translateType = this.$t(this.$translate.OrderOfCompletion);
    } else if (this.type === NumberSequenceEditTypeEnum.LearningRequest) {
      translateType = this.$t(this.$translate.LearningRequest);
    } else if (this.type === NumberSequenceEditTypeEnum.EducationProtocol) {
      translateType = this.$t(this.$translate.TrainingProtocol);
    }

    return translateType;
  }

  get editTypes(): typeof NumberSequenceEditTypeEnum {
    return NumberSequenceEditTypeEnum;
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  formatted(value: string, index: any): any {
    return sprintf(value, index);
  }

  async sequenceEdit() {
    try {
      this.isShowSpinner = true;
      const title: INumberSequenceEdit = {
        title: this.title,
        type: this.type as NumberSequenceEditTypeEnum
      };
      const { data } = await documentNumberApi.editSequence(
        this.companyId,
        this.sequence.id,
        title
      );
      this.$emit("sequenceEdit", data);
      this.isEdit = false;
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isShowSpinner = false;
    }
  }

  sequenceDelete() {
    this.isEdit = false;
    this.$emit("sequenceDelete", this.sequence);
  }
}
